import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonConstant {
  static CONSTANT_NAVIGATION = {
    HOME: '/',
  };
  static DEFAULT_SKIP_COUNT = 0;
  static DEFAULT_MAX_PAGE_RESULT_COUNT = 3;
  static DEFAULT_MAX_RESULT_COUNT = 100;
  static DEFAULT_MIN_YEAR_AVAILABLE = 2006;
  initialize() {
    // console.log(Object.keys(this));
  }
}
